<script setup>
/**
 * Toast — notification individuelle.
 * Monté par ToastContainer, jamais directement.
 */
defineProps({
  id:      { type: Number, required: true },
  message: { type: String, required: true },
  type:    { type: String, default: 'info' },
})
defineEmits(['dismiss'])

const styles = {
  success: 'bg-sage-500 text-white',
  error:   'bg-coral-600 text-white',
  warning: 'bg-gold-500 text-ink-900',
  info:    'bg-ink-900 text-white',
}

const icons = {
  success: '✓',
  error:   '✕',
  warning: '⚠',
  info:    'ℹ',
}
</script>

<template>
  <div
    role="status"
    aria-live="polite"
    class="flex items-center gap-3 rounded-2xl px-4 py-3 text-sm shadow-float max-w-sm w-full"
    :class="styles[type]"
  >
    <span class="shrink-0 text-base leading-none" aria-hidden="true">{{ icons[type] }}</span>
    <span class="flex-1">{{ message }}</span>
    <button
      type="button"
      class="shrink-0 rounded-full p-1 opacity-70 transition hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-white/40"
      aria-label="Cerrar"
      @click="$emit('dismiss', id)"
    >
      <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
      </svg>
    </button>
  </div>
</template>
